/* page transition  */
export const initTransition = function(md) {

    $("a").click(function (e) {
        e.preventDefault();
        // $("body").addClass('body--transition');

        var transitionEvent = whichTransitionEvent();
        $(".main-wrapper:not(.main-wrapper--transition)")
            .addClass('main-wrapper--transition')
            .one(transitionEvent,
            function () {
               // alert('load next page here');
                window.location = e.currentTarget.href;
            });
    });

};

function whichTransitionEvent(){
    var t,
        el = document.createElement("fakeelement");

    var transitions = {
        "transition"      : "transitionend",
        "OTransition"     : "oTransitionEnd",
        "MozTransition"   : "transitionend",
        "WebkitTransition": "webkitTransitionEnd"
    }

    for (t in transitions){
        if (el.style[t] !== undefined){
            return transitions[t];
        }
    }
}